import {getCompanyName} from '../../utils/proto-api-utils/utils';

export enum CachedFields {
    actions = 'actions',
    columns = 'columns',
    formMetaData = 'formMetaData',
    statuses = 'statuses',
    subformsList = 'subformsList',
    sysSearchCategoryConst = 'sysSearchCategoryConst'
}

type CompanyRelatedCache = {
    [company: string]: {
        [formName: string]: Map<string, any>;
    };
};

type SessionRelatedFields = {
    [session: string]: CompanyRelatedCache;
};

type StorageType = {
    common: CompanyRelatedCache;
    personal: SessionRelatedFields;
};

export class FormsCacheData {
    storage: StorageType = {common: {}, personal: {}};

    getData(formName: string, key: string, session?: string) {
        const companyScope = this.getStorage(session)[getCompanyName()];
        const formScope = companyScope?.[formName];
        if (formScope) {
            return formScope.get(key);
        }
        return null;
    }

    getStorage(session?: string) {
        if (session) {
            if (!this.storage.personal[session]) {
                this.storage.personal[session] = {};
            }

            return this.storage.personal[session];
        }
        return this.storage.common;
    }

    setData(formName: string, key: string, data: any, session?: string) {
        const companyName = getCompanyName();
        const storage = this.getStorage(session);
        const companyScope = storage[companyName];

        if (!companyScope) {
            // setup new company env
            storage[companyName] = {};
        }
        if (!storage[companyName][formName]) {
            // setup new formStorage env
            storage[companyName][formName] = new Map();
        }

        if (data) {
            storage[companyName][formName].set(key, data);
        }
    }

    clearSessionCache(session: string) {
        const storage = this.storage.personal;

        delete storage[session];
    }
}
